export default {
  facebook: 'Facebook',
  instagram: 'Instagram',
  tiktok: 'Tiktok',
  google: 'Google',
  friend: 'Empfehlung Freunde / Bekannte',
  tv: 'TV',
  focusMoney: 'FocusMoney',
  store: 'Store / Filiale',
  other: 'Sonstiges',
}

